module.exports = __webpack_public_path__ + "img/img_main_wave@2x.3939f8bd.png";